import { shallowMount } from "@vue/test-utils";
import SelectAutocomplete from "@/components/core/custom/SelectAutocomplete";

describe("SelectAutocomplete component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(SelectAutocomplete, {
      propsData: {
        items: ["Item 1", "Item 2", "Item 3"]
      }
    });
  });

  it("Renders del component SelectAutocomplete", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
